import { render, staticRenderFns } from "./StarterNavbar.vue?vue&type=template&id=36e7d47c&"
import script from "./StarterNavbar.vue?vue&type=script&lang=js&"
export * from "./StarterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./StarterNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports